import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import slug from 'constants/slug';
import { ROUTES } from 'constants/routes';
import { companyDetails } from 'redux/retailers/selector';
import { useAppSelector } from 'redux/redux';

interface MieleOnlyRouteProps {
  children: ReactNode;
}

/**
 * Confines a route to the Miele flavour. Any other flavour is redirected to the
 * retailers list. The Policy Ledger module is Miele-only for now.
 */
export const MieleOnlyRoute: FC<MieleOnlyRouteProps> = ({ children }) => {
  const companyData = useAppSelector(companyDetails);

  if (companyData?.slug !== slug.MIELE) {
    return <Navigate to={`/${ROUTES.DASHBOARD}/${ROUTES.RETAILERS}`} replace />;
  }

  return <>{children}</>;
};
